import React, {useEffect, useState} from 'react';
import GetCodeService from "../Api/GetCodeService";
import GroupCodesList from "./GroupCodesList";
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardFooter,
    MDBCardHeader,
    MDBCardText,
    MDBCardTitle,
    MDBSpinner
} from 'mdb-react-ui-kit';




const CodesManager_new = ({isLoading, zid, pod}) => {
    const [token, setToken] = useState('');
    const [codeData, setCodeData] = useState(null );
    const [fName, setCFName] = useState(false);
    let xxx=""


    //РАСКОМЕНТАРИТЬ
    // try {
    //     //initDataUnsafe.user.first_name
    //     let qid =JSON.stringify(initDataUnsafe.query_id)
    //
    //     if (qid!=undefined){
    //         setCFName(true)
    //     }
    //     // console.log(initDataUnsafe.user.id)
    //     xxx=" "
    // } catch (err) {
    //     xxx="НЕ ТЕЛЕГА"
    //     console.log("Не телега");
    //     console.log(err);
    // }


    function webviewClose() {
        window.Telegram.WebApp.close();
    }


    window.Telegram.WebApp.MainButton
        .setText('Закрыть')
        .show()
        .onClick(function(){ webviewClose(); });






    const getCodeItems = async (retries = 3, delay = 1000) => {
        try {
            const response = await GetCodeService.getCodeData(zid, pod);
            setCodeData(response);
        } catch (error) {
            console.error("Ошибка запроса:", error);

            if (retries > 0) {
                setTimeout(() => {
                    getCodeItems(retries - 1, delay);
                }, delay);
            } else {
                console.error("Лимит попыток исчерпан");
            }
        }
    };

    useEffect(() => {
        getCodeItems()
        window.Telegram.WebApp.expand()
    }, [])


    if (!codeData || codeData.length === 0)
        return <>
            <div className='text-center'>
                <MDBSpinner className='mx-2' color='warning'>
                    <span className='visually-hidden'>Loading...</span>
                </MDBSpinner>
            </div>
                </>


    return (
        <>
            <GroupCodesList Elements={codeData} zid={zid}/>
        </>
    );
};

export default CodesManager_new;
